/*
 * @Author: Garywoner
 * @Date: 2021-04-26 15:14:00
 * @Last Modified by: Garywoner
 * @Last Modified time: 2021-04-26 15:14:00
 */

import React, { Component } from "react";
import cookie from "react-cookies";

import { Select as ElementSelect, Input, Card, Button, Form} from "element-react";

import { Row, Col } from "reactstrap";

import "./index.css";

import searchLibTag from "api/searchLibTag";
import ssoRefresh from "../../api/ssoRefresh";

export default class Add_lib_private extends Component {
  state = {
    key: "",
    candidateValue: [],
    selectedValue: [],
    moreVisible: false,
  };

  handleChange = (value) => {

    const {handleUpdateLibTag} = this.props;

    var pl = this.state.selectedValue.indexOf(value);
    if (pl === -1) {
        this.state.selectedValue.push(value);
    }

    let lib_tag = this.state.selectedValue.join("/");
    handleUpdateLibTag(lib_tag);
    this.setState({["key"]: this.state.key});
  };

    hasLetter(str) {
        for (var i in str) {
            var asc = str.charCodeAt(i);
            if ((asc >= 65 && asc <= 90) || (asc >= 97 && asc <= 122)) {
                return true;
            }
        }
        return false;
    }

    notNullCheck = (str) => {
        return !(!this.hasLetter(str) && escape(str).indexOf("%u") === -1);

    }
  upkey = () => {
      if(!this.state.key || this.state.key.indexOf("/") !== -1 || this.state.key.indexOf(" ") !== -1){
          alert("库标签不可为空且不可包含“/”和空格!");
          return;
      }
      if (!this.notNullCheck(this.state.key)){
          alert("库标签应包括汉字或字母！");
          return;
      }
      const {handleUpdateLibTag} = this.props;
      var pl = this.state.selectedValue.indexOf(this.state.key);
      if (pl === -1) {
          this.state.selectedValue.push(this.state.key);
      }

      let lib_tag = this.state.selectedValue.join("/");
      handleUpdateLibTag(lib_tag);
      this.setState({["key"]: this.state.key});
  };

  handleChangeDelete = (value) => {

      const {handleUpdateLibTag} = this.props;

      var pl = this.state.selectedValue.indexOf(value);
      if (pl !== -1) {
          this.state.selectedValue = this.state.selectedValue.filter(item => item !== value);
      }

      let lib_tag = this.state.selectedValue.join("/");
      handleUpdateLibTag(lib_tag);
      this.setState({["key"]: this.state.key});
  };

    onChange = (key, value) => {
        this.setState({ [key]: value });
    };

  handleSearchLib = () => {

      searchLibTag(cookie.load("ACCESS_TOKEN"), this.state.key, 30, "true")
          .then((response) => {
              try{
                  if(response.data.data.message === "logout") {
                      ssoRefresh();
                  }
              }
              catch(e){
                  console.log(e);
              }

              this.state.candidateValue = [];
              let result = response.data.data.result;
              for(let tag in result){
                  this.state.candidateValue.push(result[tag]);
              }
              this.state.moreVisible = response.data.data.is_all === "unknown";
              this.setState({["key"]: this.state.key});
          })
          .catch((err) => {
              console.log(err);
          });
  };

  render() {
    const { title } = this.props;

    return (
      <div id="check-range-selecter">
          <Form>
              <font size="2" style={{ color: "red" }}>
                  私有库将根据您的<strong>机构及课程</strong>来划分，您入库的文档/代码包将存储在您的<strong>机构及课程</strong>的私有库中。
              </font>
          </Form>
        <Row>
          <Col lg="9" md="6" sm="2">
            <Form.Item prop="key">
            <Input
              id="check-range-title"
              value={this.state.key}
              style={{ cursor: "default" }}
              onChange={this.onChange.bind(this, "key")}
              placeholder="请输入关键字"
              prepend={
                <div style={{ width: "100px", color: "#172b4d" }}>{title}</div>
              }
              append={
                  <Button type="success" onClick={this.handleSearchLib}>
                      查询相似标签
                  </Button>
              }
            />
            </Form.Item>
          </Col>
          <Col lg="3" md="6" sm="2">
            <Button
                type="success"
                icon="check"
                onClick={this.upkey}
                style={{ width: "100%" }}
            >
                添加当前关键字
            </Button>
          </Col>
        </Row>
          <h6 className="font-weight-bold mb-1">
              <br/>
              相似库标签结果（点击可添加）
          </h6>
          <Card>
              {
                  this.state.candidateValue.map(
                      (v, index) =>{ return <Button type="primary" size="medium" className="ml-0 mr-1 my-2" onClick={() => {
                          this.handleChange(v);
                      }}>{v}</Button> }
                  )
              }
              <h7 className="font-weight mb-1"
                  style={{ display: this.state.moreVisible ? "block" : "none" }}>
                  可能还有更多搜索结果，请增加关键字信息...
              </h7>
          </Card>
          <h6 className="font-weight-bold mb-1">
              <br/>
              添加的私有库标签（点击可删除）
          </h6>
          <Card>
              {
                  this.state.selectedValue.map(
                      (v, index) =>{ return <Button type="success" size="medium" className="ml-0 mr-1 my-2" onClick={() => {
                          this.handleChangeDelete(v);
                      }}>{v}</Button> }
                  )
              }
          </Card>
      </div>
    );
  }
}
